<template>
  <layouts-header v-if="!authStore.user"></layouts-header>
  <user-header v-if="authStore.user"></user-header>
  <!--Banner & feature-->
  <home-banner></home-banner>
  <!--/Banner & feature-->

  <home-coaches></home-coaches>

  <home-plans></home-plans>

  <!-- <home-venues></home-venues> -->

  <home-service></home-service>

  <home-group></home-group>

  <!-- <home-excellence></home-excellence> -->

  <home-testimonials></home-testimonials>

  <layout-footer></layout-footer>
</template>

<script setup>
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
</script>
